export default "__VITE_ASSET__DWXL0Nud__"